import React from 'react';
import { MessageCircle, Youtube, Facebook, Instagram, Music2 } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#4F2E7E] text-brand-cream pt-20 pb-10" data-id="element-1250">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1251">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-1252">
          {/* CONTACT */}
          <div data-id="element-1253">
            <h4 className="font-heading font-bold text-sm tracking-[0.15em] text-brand-gold mb-6 uppercase" data-id="element-1254">
              Contact
            </h4>
            <ul className="space-y-4 text-base text-brand-cream/80 leading-relaxed" data-id="element-1255">
              <li data-id="element-1256">SC HUNSER S.R.L., CUI: 49492585.</li>
              <li data-id="element-1257">Adresa: Str. Progresului, Nr. 28, HUNEDOARA, ROMÂNIA</li>
              <li data-id="element-1258">
                Telefon:{' '}
                <a href="tel:+40726042604" className="hover:text-brand-gold transition-colors" data-id="element-1259">
                  0726 042 604
                </a>
              </li>
              <li data-id="element-1260">
                email:{' '}
                <a href="mailto:academia.abundentei365@gmail.com" className="hover:text-brand-gold transition-colors break-all" data-id="element-1261">
                  academia.abundentei365@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* LEGAL */}
          <div data-id="element-1262">
            <h4 className="font-heading font-bold text-sm tracking-[0.15em] text-brand-gold mb-6 uppercase" data-id="element-1263">
              Legal
            </h4>
            <ul className="space-y-4 text-base text-brand-cream/80" data-id="element-1264">
              <li data-id="element-1265">
                <a href="https://academiadeabundenta.ro/termeni-si-conditii" target="_top" className="hover:text-brand-gold transition-colors uppercase tracking-wide text-sm" data-id="element-1266">
                  Termeni și Condiții
                </a>
              </li>
              <li data-id="element-1267">
                <a href="https://academiadeabundenta.ro/politica-de-confidentialitate" target="_top" className="hover:text-brand-gold transition-colors uppercase tracking-wide text-sm" data-id="element-1268">
                  Politica de Confidențialitate
                </a>
              </li>
              <li data-id="element-1269">
                <a href="https://academiadeabundenta.ro/politica-cookies" target="_top" className="hover:text-brand-gold transition-colors uppercase tracking-wide text-sm" data-id="element-1270">
                  Politica de Cookies
                </a>
              </li>
              <li data-id="element-1271">
                <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors uppercase tracking-wide text-sm" data-id="element-1272">
                  ANPC
                </a>
              </li>
            </ul>
          </div>

          {/* SOCIAL MEDIA */}
          <div data-id="element-1273">
            <h4 className="font-heading font-bold text-sm tracking-[0.15em] text-brand-gold mb-6 uppercase" data-id="element-1274">
              Social Media
            </h4>
            <ul className="space-y-4 text-base text-brand-cream/80" data-id="element-1275">
              <li data-id="element-1276">
                <a href="https://wa.me/40726042604" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-brand-gold transition-colors" data-id="element-1277">
                  <MessageCircle size={18} className="text-brand-gold" data-id="element-1278" />{' '}
                  WhatsApp
                </a>
              </li>
              <li data-id="element-1279">
                <a href="https://youtube.com/@academiadeabundenta?si=hH71WCz3OzEx7gan" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-brand-gold transition-colors" data-id="element-1280">
                  <Youtube size={18} className="text-brand-gold" data-id="element-1281" /> Youtube
                </a>
              </li>
              <li data-id="element-1282">
                <a href="https://www.facebook.com/share/18D8cz1N2t/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-brand-gold transition-colors" data-id="element-1283">
                  <Facebook size={18} className="text-brand-gold" data-id="element-1284" /> Facebook
                </a>
              </li>
              <li data-id="element-1285">
                <a href="https://instagram.com/academia_de_abundenta" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-brand-gold transition-colors" data-id="element-1286">
                  <Instagram size={18} className="text-brand-gold" data-id="element-1287" /> Instagram
                </a>
              </li>
              <li data-id="element-1288">
                <a href="https://www.tiktok.com/@academia.de.abund" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-brand-gold transition-colors" data-id="element-1289">
                  <Music2 size={18} className="text-brand-gold" data-id="element-1290" /> Tiktok
                </a>
              </li>
            </ul>
          </div>

          {/* ANPC BADGES */}
          <div className="flex flex-col gap-4" data-id="element-1291">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="block bg-white rounded-md overflow-hidden hover:opacity-90 transition-opacity shadow-sm" data-id="element-1292">
              <img src="https://cdn.magicpatterns.com/uploads/bQRrxC6NyL8Mm2Q35u6wZ6/ANPC.webp" alt="ANPC - Soluționarea Alternativă a Litigiilor" className="w-full h-auto block" data-id="element-1293" />
            </a>
            <a href="https://consumer-redress.ec.europa.eu/site-relocation_en" target="_blank" rel="noopener noreferrer" className="block bg-white rounded-md overflow-hidden hover:opacity-90 transition-opacity shadow-sm" data-id="element-1294">
              <img src="https://cdn.magicpatterns.com/uploads/eZ4bvmtw61spsG1PotZB4s/SAL.jpg" alt="SOL - Soluționarea Online a Litigiilor" className="w-full h-auto block" data-id="element-1295" />
            </a>
          </div>
        </div>

        {/* Separator & Copyright */}
        <div className="pt-8 border-t border-brand-cream/15 text-center" data-id="element-1296">
          <p className="text-sm text-brand-cream/70" data-id="element-1297">
            © Copyright {new Date().getFullYear()}.{' '}
            <strong className="text-brand-cream font-bold" data-id="element-1298">
              SC HUNSER S.R.L.
            </strong>{' '}
            Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>;
}